import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, Select, Textarea } from 'tdesign-react';
import Text from '@/components/Text';
import { addInspect, updateInspect } from '@/services/inspectService';
import { isVoid, toTsOptions } from '@/utils/common';
import { colors } from '@/utils/constant';

const { FormItem } = Form;

export const options = [
  'Topic',
  'ConsumerGroup',
  'Zookeeper',
  'Broker',
  'Geo_Replication',
  'Bookie',
  'Node',
].map((item, index) => ({ label: item, value: item, color: colors[index] }));

export default function FormModal({ visible, handleClose, detail }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const isEdit = !isVoid(detail);

  useEffect(() => {
    if (visible) {
      form.reset();
      if (isEdit) {
        setTimeout(() => form.setFieldsValue(detail), 50);
      }
    }
  }, [visible, form, isEdit, detail]);

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setSubmitting(true);
        if (isEdit) {
          const { updateTime, ...others } = detail;
          await updateInspect({
            ...others,
            metricsType: 'prometheus', // 预留，写死
            ...fields,
          });
        } else {
          await addInspect({ ...fields, metricsType: 'prometheus' });
        }
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Dialog
      header={isEdit ? '修改巡检' : '新增巡检'}
      onClose={() => handleClose()}
      visible={visible}
      onConfirm={() => form.submit()}
      confirmBtn={{
        loading: submitting,
        content: '确认',
      }}
      width={600}
    >
      <Form form={form} style={{ width: '90%' }} onSubmit={handleSubmit}>
        <FormItem name='metricsMode' label='巡检模块' rules={[{ required: true }]}>
          {isEdit ? <Text /> : <Select options={toTsOptions(options)} />}
        </FormItem>
        <FormItem name='metricsName' label='巡检名称' rules={[{ required: true }]}>
          {isEdit ? <Text /> : <Input />}
        </FormItem>
        <FormItem name='metricsRules' label='巡检规则' rules={[{ required: true }]}>
          {isEdit ? <Text /> : <Input />}
        </FormItem>
        <FormItem name='threshold' label='阈值' rules={[{ required: true }]}>
          <Input />
        </FormItem>
        <FormItem name='metricsDescription' label='巡检说明' rules={[{ required: true }]}>
          <Textarea placeholder='巡检说明' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
